import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { CfPopoverBase } from 'components/popover-host/popover-interface';
import { PopoverController } from 'providers/popover-controller';

@Component({
  selector: 'cs-tooltip-popover',
  templateUrl: 'cs-tooltip-popover.html',
  standalone: false,
  host: { 'class': 'tooltip-popover' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTooltipPopover extends CfPopoverBase {
  tooltipContent: string;
  tooltipTemplate: TemplateRef<any>;
  tooltipTitle: string;
  tooltipDescription: string;
  buttonText: string;
  buttonCallback: () => void;

  constructor(private popoverCtrl: PopoverController) {
    super();
  }

  onButtonClick() {
    if (this.buttonCallback) {
      this.buttonCallback();
    }
    void this.popoverCtrl.dismiss(this);
  }

  onWillDismiss(): void {}
}